export const environment = {
  production: false,
  //url: "https://api-motor.policystreet.app",
  //crmUrl: "https://api-crm.policystreet.app",
  //signalrHubUrl: "https://api-crm.policystreet.app/hub",
  url: "https://api-motor-enc.policystreet.app",
  crmUrl: "https://api-crm-enc.policystreet.app",
  signalrHubUrl: "https://api-crm-enc.policystreet.app/hub",
  googleTagId: "",
  cleverTapId: "TEST-4R4-ZK8-557Z"
};
